import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiConfiguration } from '@/core/api/api-configuration';
import { BaseService } from '@/core/api/base-service';
import { environment } from '@env/environment';

import { PortalModulo } from './portal-modulo.model';

@Injectable({ providedIn: 'root' })
export class PortalModuloService extends BaseService {
    readonly PATH = environment.basePath + '/portal/modulo';

    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http, environment.apis.apiSicom);
    }

    /** Lista os módulos do dashboard já filtrados pela UF do usuário autenticado — `GET /portal/modulo`. */
    listar(): Observable<PortalModulo[]> {
        return this.http.get<PortalModulo[]>(this.PATH);
    }
}
